import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import useTimeTicketWeekService from '@/services/time-ticket/TimeTicketWeekService';

type Props = SetupProps<typeof DashboardTimeTicketToFillCardSetupService.props>

export default class DashboardTimeTicketToFillCardSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	private readonly state = reactive({
		numberToProceed: 0,
		dataLoaded: false,
	});

	get numberToProceed () { return this.state.numberToProceed; }
	get dataLoaded () { return this.state.dataLoaded; }

	get label () {
		return `${ 'relevé'.pluralize(this.state.numberToProceed, false)} d'heures à saisir ${this.self.isClient() ? 'cette semaine' : ''} `;
	}

	constructor (props?: Props) {
		super(props);
	}

	protected async onBeforeMountAsync () {
		this.state.numberToProceed = await useTimeTicketWeekService().countToFillAsync();
		this.state.dataLoaded = true;
	}

	goToTimeTicket () {
		if (this.self.isClient()) {
			this.router.push({
				name: 'TimeTicketYear',
				params: { year: new Date().getFullYear() },
			});
		} else if (this.self.isTempWorker()) {
			this.router.push({ name: 'TimeTicket' });
		}
	}
}
